module.exports = __webpack_public_path__ + "static/media/hand-stars.498727dd.png";